import React from "react";
import { Typography } from "@mui/material";
import { Icon } from "@phosphor-icons/react";

interface DashboardHeaderProps {
  title: React.ReactNode;
  Icon: Icon;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({ title, Icon }) => {
  return (
    <Typography component="h2" variant="h1" style={{ fontWeight: 500, marginBottom: "24px" }}>
      <Icon size={24} weight="duotone" color="#8E42CA" style={{ marginRight: 8 }} />
      {title}
    </Typography>
  );
};

export default DashboardHeader;
